const MARKETS_CARD_TYPES = {
  SCALPER_CARNIVAL_CARD: 'Scalper Carnival',
  OPTION_LEADERBOARD: 'Options Leaderboard',
  FUTURES_SCALPER_CARNIVAL_CARD: 'Scalper Carnival Futures',
} as const;

const LIVE_NOW_TAG_ELIGIBLE_CARDS = [
  MARKETS_CARD_TYPES.SCALPER_CARNIVAL_CARD,
  MARKETS_CARD_TYPES.OPTION_LEADERBOARD,
  MARKETS_CARD_TYPES.FUTURES_SCALPER_CARNIVAL_CARD,
] as const;

const SIGNAL_TRADING = 'Signal Trading';

export { MARKETS_CARD_TYPES, LIVE_NOW_TAG_ELIGIBLE_CARDS, SIGNAL_TRADING };
